// @flow

import React from "react";

import { Section, Card, ChangePasswordForm } from "buba-components";

type ChangePasswordProps = {
  passwordRegex: RegExp,
  passwordError: string,
  addMessage: (React.Node, "success" | "failure") => void,
  changePasswordAction: ({
    oldPassword: string,
    password: string,
    passwordConfirmation: string
  }) => Promise<*>
};

const submitForm = (addMessage, changePasswordAction) => mapFormErrors => values =>
  changePasswordAction(values)
    .then(() => {
      addMessage("Vielen Dank! Ihr Passwort wurde erfolgreich geändert.", "success");
    })
    .catch(err => {
      if (err && err.response && err.response.status) {
        if (err.response.status === 422) {
          mapFormErrors(err.response);
        } else {
          addMessage(
            "Das Passwort konnte nicht geändert werden. Bitte ausloggen and loggen Sie sich erneut ein.",
            "failure"
          );
        }
      }
    });

const ChangePassword = ({
  passwordRegex,
  passwordError,
  addMessage,
  changePasswordAction
}: ChangePasswordProps) => (
  <Section title="Wollen Sie Ihr Passwort ändern?" reducedMargin expandable>
    <Card>
      <header>Neues Passwort festlegen</header>
      <ChangePasswordForm
        submitForm={submitForm(addMessage, changePasswordAction)}
        passwordRegex={passwordRegex}
        passwordError={passwordError}
      />
    </Card>
  </Section>
);

export default ChangePassword;
